import axios from 'axios';

const auth = (token) => ({ Authorization: token });

export const listMainAuthors = async (page, filters, order, sort, token) => {
  return axios.post(`${ process.env.REACT_APP_API_URL }main/authors/list`, {page, order, sort, filters},{ headers: auth(token) });
}

export const getMainAuthor = async (id, token) => axios.get(`${ process.env.REACT_APP_API_URL }main/authors/${id}`, {headers: auth(token)});

export const createMainAuthor = async (data, token) => {
  return axios.post(`${ process.env.REACT_APP_API_URL }main/authors`, data, {headers: auth(token)});
}

export const updateMainAuthor = async (data, token) => {
  return axios.put(`${ process.env.REACT_APP_API_URL }main/authors`, data, {headers: auth(token)});
}

export const searchMainAuthor = async (term, userStore) => {
  const result = await axios.get(`${ process.env.REACT_APP_API_URL }main/authors/search?term=${term}`, {headers: auth(userStore.token)});
  const list = [];
  for (let data of result.data.data) {
    list.push(data);
  }
  return list;
};
